module.exports = __webpack_public_path__ + "static/media/LockWithCircleIcon.46f84385.svg";